var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"on-manager":_vm.onManager,"base-info":_vm.baseInfo,"status-module":"rds","data":_vm.data,"resource":"dbinstances","extra-info":_vm.extraInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }